<template>
  <!-- <div id="editor" style="width: 100%;">333</div> -->
  <div>
    <!-- 图片上传 -->
    <Upload
      v-show="false"
      :ref="'imageUpload' + classRandom"
      :random="classRandom"
      :inputClass="'editorImage' + classRandom"
      :listType="'picture-card'"
      path="b/editor-135/upload"
      @uploadChange="handleExceed"
    ></Upload>
    <!-- 视频上传 -->
    <Upload
      v-show="false"
      :ref="'videoUpload' + classRandom"
      :random="classRandom"
      :inputClass="'editorVideo' + classRandom"
      :listType="'text'"
      :accept="'video/*'"
      path="b/editor-135/upload"
      @uploadChange="videoChange"
      @beforeUpload="beforeUploadVideo"
    ></Upload>
    <!-- 语音上传 -->
    <Upload
      v-show="false"
      :isRename="false"
      :ref="'audioUpload' + classRandom"
      :random="classRandom"
      :inputClass="'editorAudio' + classRandom"
      :listType="'text'"
      :accept="'audio/*'"
      path="b/editor-135/upload"
      @uploadChange="audioChange"
      @beforeUpload="beforeUploadAudio"
    ></Upload>
    <iframe
      v-if="iframeSrc"
      :ref="'editor135-iframe'+ classRandom"
      style="width: 100%;min-height:200px"
      frameborder="0"
      :src="iframeSrc"
      :data-random="classRandom"
    ></iframe>
  </div>
</template>
<script>
import { transformUrl } from '@/utils/util'
import Vue from 'vue'
// import Upload from '@/components/Upload'
const Upload = () => import('@/components/Upload/Upload')
export default {
  components: {
    Upload
  },
  data() {
    return {
      iframe: null,
      iframeWindow: null,
      editor135: null,
      domain: window.location.host,
      domainSuffix: '',
      iframeSrc: '',
      classRandom: Math.floor(Math.random() * 10000).toString() // 多个文本框
    }
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    isShowLib: {
      type: Boolean,
      default: false
    },
    audioCover: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'content',
    event: 'change'
  },

  watch: {
    content(newVal, oldVal) {
      if (this.editor135 && newVal !== this.getContent()) {
        if (newVal) {
          this.editor135.setContent(newVal)
        } else {
          this.editor135.setContent('<p></p>')
        }
      }
    }
  },
  created() {
    if (this.domain.split('.')[2]) {
      this.domainSuffix = this.domain.split('.')[1] + '.' + this.domain.split('.')[2]
    }

    const srcPrefix =
      process.env.NODE_ENV === 'development'
        ? '//' + this.domain + '/assets/lib/135editor'
        : '//editor.' + this.domainSuffix + '/135editor'
    this.iframeSrc = srcPrefix + '/index.html?' + this.domainSuffix
    if (process.env.NODE_ENV !== 'development') {
      document.domain = this.domainSuffix
    }
  },
  mounted() {
    this.iframe = this.$refs['editor135-iframe' + this.classRandom]
    const _self = this
    this.iframe.onload = () => {
      _self.iframeWindow = this.iframe.contentWindow
      _self.modelChange()
      const appkey = process.env.VUE_APP_EDIT_KEY
      _self.iframeWindow.UEDITOR_CONFIG['wordCount'] = true
      // let domain = window['domainIsCurrentPosition'] ? 'http://' + window.location.host : environment.domain
      //   _self.iframeWindow.UEDITOR_CONFIG['serverUrl'] = process.env.VUE_APP_API_BASE_URL + '/oss/oss/obsUpload'
      //   _self.iframeWindow.UEDITOR_CONFIG['imagePath'] = '/ueditor/'
      //   _self.iframeWindow.UEDITOR_CONFIG['imageUrlPrefix'] = process.env.VUE_APP_OBS_URL + '/data'
      // _self.iframeWindow.UEDITOR_HOME_URL = '/assets/lib/135editor/'lang:"zh-cn"
      _self.iframeWindow.UEDITOR_CONFIG['toolbars'] = [
        [
          'bold',
          'italic',
          'underline',
          'forecolor',
          'shadowcolor',
          'backcolor',
          '|',
          'justifyleft',
          'justifycenter',
          'justifyright',
          'justifyjustify',
          'indent',
          'rowspacingtop',
          'rowspacingbottom',
          'lineheight',
          '|',
          'removeformat',
          'formatmatch',
          'autotypeset'
        ],
        [
          'cleardoc',
          'paragraph',
          'fontfamily',
          'fontsize',
          'inserttable',
          'addimage',
          // 'insertvideo',
          'addaudio',
          // 'music',
          'addvideo',
          //   'background',
          //   'simpleupload',
          'horizontal',
          '|',
          'undo',
          'redo'
        ],
        [
          'source',
          //   'remotecontent',
          'spechars',
          'emotion',
          'link',
          'superscript',
          'subscript',
          'insertorderedlist',
          'insertunorderedlist',
          'directionalityltr',
          'directionalityrtl',
          'searchreplace',
          'help'
        ]
      ]
      _self.addImageBtn()
      _self.addVideoBtn()
      _self.addAudioBtn()
      if (_self.iframeWindow.initEditor) {
        _self.editor135 = this.iframe.contentWindow.initEditor(this.pw, this.ph, appkey)
        _self.editor135.ready(() => {
          _self.iframe.style.height = _self.iframeWindow.document.body.clientHeight + 'px'
          _self.editor135.addListener('contentchange', value => {
            _self.$emit('change', _self.editor135.getContent())
          })
          _self.editor135.setContent(_self.content ? _self.content : '<p></p>')
          if (!_self.isShowLib && _self.iframeWindow.document.querySelector('.edui-editor-sidebar')) {
            _self.iframeWindow.document.querySelector('.edui-editor-sidebar').style.display = 'none'
          }
        })
      }
    }
  },
  beforeDestroy() {
    this.$emit('change', this.editor135.getContent())
    this.editor135.destroy()
  },
  methods: {
    addImageBtn() {
      const _this = this
      _this.iframeWindow.UE.registerUI('addimage', function(editor, uiName) {
        // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
        // editor.registerCommand(uiName, {
        //   execCommand: function() {
        //     alert('execCommand:' + uiName)
        //   }
        // })
        // 创建一个button
        const btn = new _this.iframeWindow.UE.ui.Button({
          // 按钮的名字
          name: uiName,
          // 提示
          title: '图片上传',
          // 添加额外样式，指定icon图标，这里默认使用一个重复的icon
          cssRules: 'background-position: -380px 120px;',
          // 点击时执行的命令
          onclick: function(e) {
            // console.log('点击图片', _this.classRandome)
            // console.log('this', _this)
            Vue.$editor = _this.classRandom
            _this.$refs['imageUpload' + _this.classRandom].uploadClick()
          }
        })
        // 因为你是添加button,所以需要返回这个button
        return btn
      })
    },
    addVideoBtn() {
      const _this = this
      _this.iframeWindow.UE.registerUI('addvideo', function(editor, uiName) {
        const btn = new _this.iframeWindow.UE.ui.Button({
          name: uiName,
          title: '本地视频上传',
          cssRules: 'background-position: -321px -20px;',
          onclick: function(e) {
            Vue.$editor = _this.classRandom
            _this.$refs['videoUpload' + _this.classRandom].uploadClick()
          }
        })
        return btn
      })
    },
    addAudioBtn() {
      const _this = this
      _this.iframeWindow.UE.registerUI('addaudio', function(editor, uiName) {
        const btn = new _this.iframeWindow.UE.ui.Button({
          name: uiName,
          title: '本地语音上传',
          cssRules: 'background-position: -20px 560px',
          onclick: function(e) {
            Vue.$editor = _this.classRandom
            _this.$refs['audioUpload' + _this.classRandom].uploadClick()
          }
        })
        return btn
      })
    },
    modelChange(model) {
      this.pw = this.isShowLib ? 320 : -1
      this.ph = this.isShowLib ? 568 : 300
      this.iframe.style.minWidth = this.pw * 2 + 2 + 'px'
      this.iframe.style.height = this.ph + 100 + 'px'
    },
    handleExceed(url) {
      const image = url.length > 0 ? transformUrl(url[url.length - 1]) : ''
      this.editor135.execCommand('insertHtml', "<img src='" + image + "' />")
      this.$emit('change', this.editor135.getContent())
    },
    videoChange(url) {
      const video = url.length > 0 ? transformUrl(url[url.length - 1]) : ''
      this.editor135.execCommand('insertHtml', "<video style='width:100%' src='" + video + "' />")
      this.$message.destroy()
      this.$message.success('插入成功')
      this.$emit('change', this.editor135.getContent())
    },
    audioChange(url) {
      const _self = this
      const audio = url.length > 0 ? transformUrl(url[url.length - 1]) : ''
      const urlArray = audio.split('/')
      const urlFile = urlArray[urlArray.length - 1]
      this.editor135.execCommand(
        'insertHtml',
        "<audio style='width:100%;min-height:50px;' name='" +
          urlFile +
          "' poster='" +
          (_self.audioCover ? _self.audioCover : '') +
          "' controls='true' src='" +
          audio +
          "' />"
      )
      this.$message.destroy()
      this.$message.success('插入成功')
      this.$emit('change', this.editor135.getContent())
    },
    getContent() {
      return this.editor135.getContent()
    },
    beforeUploadVideo(file) {
      this.$message.loading('正在上传视频', 0)
    },
    beforeUploadAudio(file) {
      this.$message.loading('正在上传语音', 0)
    }
  }
}
</script>
